module.exports = __webpack_public_path__ + "img/Nano.2a82abb0.jpg";